import dayjs from 'dayjs';
// A second entry of the same type on one day is a separate line, never a sum.
export function groupMatrixRows(rows) {
    const occurrences = new Map();
    const groups = new Map();
    rows.forEach(row => {
        const dateKey = `${row.date.slice(0, 10)}:${row.assignmentReasonId}`;
        const occurrence = occurrences.get(dateKey) ?? 0;
        occurrences.set(dateKey, occurrence + 1);
        const key = `${row.assignmentReasonId}:${occurrence}`;
        const group = groups.get(key) ?? { key, typeId: row.assignmentReasonId, occurrence, rows: [] };
        group.rows.push(row);
        groups.set(key, group);
    });
    return Array.from(groups.values());
}
export function matrixDates(firstDate) {
    if (!firstDate)
        return [];
    const first = dayjs(firstDate);
    const monday = first.subtract((first.day() + 6) % 7, 'day');
    return Array.from({ length: 7 }, (_, index) => monday.add(index, 'day').format('YYYY-MM-DD'));
}
